const { ServiceRequestStatus } = require('./reservation');

const CurrentStatus = {
  Call: ServiceRequestStatus.PENDING,
  Canceled: ServiceRequestStatus.CANCELLED,
  'In Progress': ServiceRequestStatus.PENDING,
  'On Hold': ServiceRequestStatus.PENDING,
  'Request Reassignment': ServiceRequestStatus.PENDING,
  Scheduled: ServiceRequestStatus.PENDING,
  Web: ServiceRequestStatus.PENDING,
  'Work Completed': ServiceRequestStatus.COMPLETED,
  _Values: () =>
    Object.keys(CurrentStatus)
      .filter(key => typeof CurrentStatus[key] !== 'function')
      .map(key => CurrentStatus[key]),
};

module.exports = { CurrentStatus };
